import { Controller } from "@hotwired/stimulus"

// Handles auto-fill behaviours on the inventory item form:
// - When article select changes, pre-fill name if blank
// - When found_at select changes, same behaviour (secondary signal)
export default class extends Controller {
  static targets = ["nameInput"]

  // Called by data-action="article-select:change->inventory-form#articleChanged"
  articleChanged(event) {
    if (!this.hasNameInputTarget) return
    const { text } = event.detail
    if (this.nameInputTarget.value.trim() === "" && text) {
      this.nameInputTarget.value = text
    }
  }
}
